import React from 'react';
import { PersonItems } from './PersonItems';

export const PersonsList = () => {
  return <PersonItems />;
};
